export default __webpack_public_path__ + "static/01_howToRideTier_desktop-e8a8fd5dd4962768d0b98f93237e8c41.png";